import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import classNames from "classnames";

import useCurrency from "@state/hooks/shared/useCurrency";
import { ErrorMessage, RequiredMark } from "@components/inputs/shared";
import { FormInputFieldCurrencyProps } from "./types";

export default function FormInputFieldCurrencyTemplate(
	props: FormInputFieldCurrencyProps
) {
	const {
		type = "text",

		id = `id--${Math.floor(1000 + Math.random() * 9000)}`,
		name,
		label,

		required = false,
		validate,
		errorMessage = undefined,
		pattern,

		placeholder,

		className,
		labelClassName,
		inputClassName = undefined,

		providedCurrency,

		...rest
	} = props;

	const form = useFormContext();
	const field = form.register(props.name, {
		required: {
			value: required,
			message: errorMessage || "COMMON.REQUIRED_FIELD",
		},
		validate,
		pattern,
	});
	const { t } = useTranslation();
	const { currency } = useCurrency();

	const labelClasses = classNames("label", labelClassName);

	const inputClasses = classNames(
		"form__field--icon__input",
		inputClassName,
		{
			"input input--base":
				inputClassName == undefined || inputClassName == null,
		}
	);

	return (
		<div className={className}>
			<label htmlFor={id} className={labelClasses}>
				{t(label)}
				<RequiredMark required={required} />
			</label>

			<ErrorMessage name={name} />

			<div className="form__field--icon">
				{/* @ts-expect-error - error because defaultValue is number*/}
				<input
					type={type}
					id={id}
					placeholder={t(placeholder || "")}
					className={inputClasses}
					{...field}
					{...rest}
				/>

				<span className="form__field--currency__symbol">
					{providedCurrency != null ? providedCurrency : currency}
				</span>
			</div>
		</div>
	);
}
